import get from 'lodash/get'
import { RequestRecord } from './request.record'

export class ContractCreationRequestRecord extends RequestRecord {
  constructor (record) {
    super(record)
    this._record = record
    this.contractor = this._record.contractor
    this.customer = this._record.reviewer
    this.escrow = get(this._record, 'details.contract.escrow')
    this.startTime = get(this._record, 'details.contract.start_time')
    this.endTime = get(this._record, 'details.contract.end_time')
    this.details = this._record.details
    this.contractNumber = get(this._record, 'details.contract.details.contract_number')
  }
}



// WEBPACK FOOTER //
// ./src/js/records/contract_creation_request.record.js